import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
export function ProductHeroSection() {
  const [selectedImage, setSelectedImage] = useState(0);
  const images = ['https://cdn.magicpatterns.com/uploads/76x41AeJfoY4b3NAgLoMt1/DIY_KIt.png', 'https://cdn.magicpatterns.com/uploads/eBdirEmDm2gYo3UiDGb4a6/CloseUp.png'];
  const features = ['Plug-and-play electric operation (no batteries)', '75-foot hose for extended reach', 'Trigger-jet spray wand', 'Siphons directly from external containers', 'Automatic 60 PSI shutoff', 'Fully customizable mounting options'];
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-900">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-901">
        {/* Image Column */}
        <div className="flex flex-col gap-4" data-id="element-902">
          <div className="bg-gray-100 rounded-xl overflow-hidden aspect-square flex items-center justify-center border border-gray-200 relative" data-id="element-903">
            <img src={images[selectedImage]} alt="ForceX DIY Kit" className="w-full h-full object-contain p-4" data-id="element-904" />
          </div>

          {/* Thumbnails */}
          <div className="grid grid-cols-4 gap-4" data-id="element-905">
            {images.map((img, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`bg-gray-50 rounded-lg overflow-hidden aspect-square border-2 transition-all ${selectedImage === index ? 'border-brand-yellow ring-2 ring-brand-yellow/20' : 'border-transparent hover:border-gray-300'}`} data-id="element-906">
                <img src={img} alt={`View ${index + 1}`} className="w-full h-full object-contain p-2" data-id="element-907" />
              </button>)}
          </div>
        </div>

        {/* Content Column */}
        <div data-id="element-908">
          <div className="mb-2" data-id="element-909">
            <span className="inline-block bg-brand-yellow/20 text-brand-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-910">
              Intro Pricing Available
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-911">
            ForceX – DIY Kit
          </h1>
          <p className="text-xl text-brand-yellow font-bold mb-6" data-id="element-912">
            Build it your way. Spray smarter. Move faster.
          </p>

          <div className="prose prose-lg text-gray-600 mb-8" data-id="element-913">
            <p data-id="element-914">
              The ForceX DIY Kit is designed for contractors who want
              flexibility without compromise. This plug-and-play electric
              sprayer pulls solution directly from any external
              container—eliminating pouring, lifting, and chemical spills.
            </p>
            <p className="mt-4" data-id="element-915">
              Mount the system to toolboxes, buckets, or custom setups. If it
              holds liquid, you can build a sprayer around it.
            </p>
          </div>

          <div className="bg-brand-light p-6 rounded-lg mb-8 border border-gray-200" data-id="element-916">
            <h3 className="font-bold text-brand-dark mb-4 text-lg" data-id="element-917">
              Key Features
            </h3>
            <ul className="space-y-3" data-id="element-918">
              {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-919">
                  <Check className="h-5 w-5 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-920" />
                  <span className="text-gray-700" data-id="element-921">{feature}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-922">
            <div className="text-3xl font-bold text-brand-dark" data-id="element-923">$639.99</div>
            <Link to="/contact" className="flex-grow sm:flex-grow-0" data-id="element-924">
              <button className="w-full sm:w-auto inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide bg-brand-yellow text-brand-dark hover:bg-yellow-400 focus:ring-brand-yellow h-14 px-8 text-lg" data-id="element-925">
                Buy Now
              </button>
            </Link>
          </div>
          <p className="mt-4 text-sm text-gray-500" data-id="element-926">
            *First-time purchaser discounts available. Contact us for bulk
            pricing.
          </p>
        </div>
      </div>
    </div>;
}